 /**
 * Arlo SFCC Static
 * New Secure Page entry point.
 */
import SecureNav from './components/npi/SecureNav';
import SecureChart from './components/npi/SecureChart';
import SecureOverview from './components/npi/SecureOverview';
import SecureCards from './components/npi/SecureCards';
import BackToTop from './components/npi/BackToTop';
import SecurePeriodSwitcher from './components/npi/SecurePeriodSwitcher';
import SecureAllServices from './components/npi/SecureAllServices';
import SecureCardsPlans from './components/npi/SecureCardsPlans';
import SecurePlansComparation from './components/npi/SecurePlansComparation';
import VideoModal from './components/VideoModal';

new SecureChart(); // eslint-disable-line no-new
new SecureCards(); // eslint-disable-line no-new
new SecureOverview(); // eslint-disable-line no-new
new BackToTop(); // eslint-disable-line no-new
new SecureNav(); // eslint-disable-line no-new
new SecurePeriodSwitcher(); // eslint-disable-line no-new
new SecureAllServices(); // eslint-disable-line no-new
new SecureCardsPlans(); // eslint-disable-line no-new
new SecurePlansComparation(); // eslint-disable-line no-new

$('body').on('click', '.js-buynowmodal-trigger', function (e) {
    e.preventDefault();
    var dataLayer = window.dataLayer;
    if (!!dataLayer) { // eslint-disable-line no-extra-boolean-cast
        var currency = $('.js-ats-gtmcurrency').val();
        var quantityObj = { quantity: 1 };
        var obj = {
            event: 'addToCart',
            ecommerce: {
                add: {
                    products: []
                },
                currencyCode: currency
            }
        };
        var pid = $(this).data('atspid');
        var productObject = $.parseJSON($('.js-ats-gtmproddata[data-gtmpid="' + pid + '"]').attr('data-gtmdata'));
        obj.ecommerce.add.products.push($.extend(productObject, quantityObj));
        dataLayer.push(obj);
    }
    var url = $(this).data('action');
    $('.js-buynow-footer').find('a.js-ats-buynow-action').attr('href', url);
    if (Number($('.minicart .cart-count').text().trim()) > 0) {
        $('#buyNowConfirmModal').modal('show');
    } else {
        $('a.js-ats-buynow-action')[0].click();
    }
});

$('.js-video-trigger').each(function () {
    new VideoModal('#' + $(this).data('modalId'));// eslint-disable-line no-new
});

$('body').on('click', '.ats-FAQ-tabs .tab', function (e) {
    e.preventDefault();
    $('.ats-FAQ-tabs .tab').removeClass('active');
    $(this).addClass('active');
    $('.faq-ats').addClass('d-none');
    var slectedTab = $(this).attr('data-tab');
    $('.' + slectedTab).removeClass('d-none');
});

/**
 * ATS page 3 cards slick slider
 */
function initializeSlick() {
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.slider-nav',
        initialSlide: 1,
        dots: true
    });

    $('.slider-nav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        initialSlide: 1
    });
}

var $window = $(window);
var $safeSecureCards = $('.safe-secure-cards');
var isSlickInitialized = false;

/**
 * ATS page safe secure cards slick slider
 */
function safeinitSlick() {
    if ($window.width() < 769) {
        if (!isSlickInitialized) {
            $safeSecureCards.slick({
                slidesToShow: 1,
                dots: true,
                slidesToScroll: 1
            });
            isSlickInitialized = true;
        }
    } else {
        // eslint-disable-next-line no-lonely-if
        if (isSlickInitialized) {
            $safeSecureCards.slick('unslick');
            isSlickInitialized = false;
        }
    }
}

// Initialize Slick on page load
initializeSlick();

// Initialize on page load
safeinitSlick();

// Trigger Modals on hover
$('.byb-info-icon').on('mouseover', function () {
    if ($(this).data('toggle') === 'modal') {
        $($(this).data('target')).modal('show');
    }
});

$(document).on('click', '.js-getstarted-button', function () {
    var viewportWidth = $(window).width();
    if (viewportWidth < 992) {
        $('html,body').animate({
            scrollTop: $('#secure-chart-mobile').offset().top - 25
        }, 1000);
    } else {
        $('html,body').animate({
            scrollTop: $('.secure-chart-getstarted').offset().top - 150
        }, 1000);
    }
});

$('#buyNowConfirmModal').on('hidden.bs.modal', function () {
    if ($('.modal.show').length === 1) {
        $('body').addClass('modal-open');
    } else {
        $('body').removeClass('modal-open');
    }
});
